import React from 'react';
import { useState, useEffect } from 'react'
import Trend from './Trend';
import ChooseTrend from './ChooseTrend';
import ChooseHeadline from './ChooseHeadline';
import CopyDownload from './CopyDownload';
// import Tooltips from './tooltips/ToolTips';
import { BrandVoiceProvider } from '../contexts/BrandVoiceContext';

export default function Main({ selectedBlog, clearSelectedBlog, refreshSidebar, onResetRegister }) {
    
    const [state, setState] = useState('start');
    const [previousState, setPreviousState] = useState(null);
    const [trendData, setTrendData] = useState([]);
    const [originalKeyword, setOriginalKeyword] = useState('');
    const [selectedTrendQuery, setSelectedTrendQuery] = useState('');
    const [h1Data, setH1Data] = useState(null);
    const [h1Selected, setH1Selected] = useState(null);
    const [h2Data, setH2Data] = useState(null);
    const [isStreaming, setIsStreaming] = useState(false);
    const [currentBlog, setCurrentBlog] = useState(null);
    const [isFromSidebar, setIsFromSidebar] = useState(false);

    // Function to reset to start state - clear all data
    const resetToStart = () => {
        setState('start');
        setPreviousState(null);
        setTrendData([]);
        setOriginalKeyword('');
        setSelectedTrendQuery('');
        setH1Data(null);
        setH1Selected(null);
        setH2Data(null);
        setIsStreaming(false);
        setCurrentBlog(null);
        setIsFromSidebar(false);
    };

    // Navigation function to move to next state
    const navigateToState = (newState) => {
        setPreviousState(state);
        setState(newState);
        // Reset sidebar flag when navigating normally
        setIsFromSidebar(false);
    };

    // Back navigation function with data clearing
    const navigateBack = () => {
        if (!previousState) return;
        
        // Clear data based on current state
        switch (state) {
            case 'new-trend':
                // Going back to start - clear trend data
                setTrendData([]);
                setOriginalKeyword('');
                break;
            case 'new-headline':
                // Going back to new-trend - clear headline data
                setH1Data(null);
                break;
            case 'copy-download':
                // Going back to new-headline - clear content data
                setH2Data(null);
                setH1Selected(null);
                setCurrentBlog(null);
                setIsStreaming(false);
                break;
            default:
                break;
        }
        
        // Reset sidebar flag when navigating back
        setIsFromSidebar(false);
        
        setState(previousState);
        setPreviousState(getStateBefore(previousState));
    };

    // Helper function to get the state before a given state
    const getStateBefore = (currentState) => {
        const stateOrder = ['start', 'new-trend', 'new-headline', 'copy-download'];
        const currentIndex = stateOrder.indexOf(currentState);
        return currentIndex > 0 ? stateOrder[currentIndex - 1] : null;
    };

    // Get breadcrumb data
    const getBreadcrumbData = () => {
        const states = ['start', 'new-trend', 'new-headline', 'copy-download'];
        const currentIndex = states.indexOf(state);
        
        return states.map((stateName, index) => ({
            state: stateName,
            isCompleted: index <= currentIndex,
            isCurrent: index === currentIndex
        }));
    };

    // Register reset function with parent on mount
    useEffect(() => {
        if (onResetRegister) {
            onResetRegister(resetToStart);
        }
    }, [onResetRegister]);

    // Handle blog selection from sidebar or profile page
    useEffect(() => {
        if (selectedBlog) {
            // Set the blog data
            setCurrentBlog(selectedBlog);
            setH1Selected(selectedBlog.h1Title);
            setH2Data(selectedBlog.content);
            
            // Mark as coming from sidebar (no navigation breadcrumbs/back button)
            setIsFromSidebar(true);
            
            // Navigate to copy-download state
            setPreviousState(null); // No previous state when coming from sidebar
            setState('copy-download');
            
            // Clear the selected blog after loading
            if (clearSelectedBlog) {
                clearSelectedBlog();
            }
        }
    }, [selectedBlog, clearSelectedBlog]);

    //handels the response from the choosTrend buttons.
    //sets the h1Data
    const handleTrendResponse = (data) => {
        setTrendData(data.responseData);
        setOriginalKeyword(data.originalKeyword);
        // Reset sidebar flag when starting new flow
        setIsFromSidebar(false);
        // setTrendDisplayData(responseData.slice(0, 5));
        // setTrendRemainingData(responseData.slice(5))
        // console.log(data.responseData[0].query);
    };

    //handels the response from the choosTrend buttons
    //sets the h1Data and records which trend query was selected
    const handleChooseTrendResponse = (data, trendQuery) => {
        setH1Data(data);
        setSelectedTrendQuery(trendQuery || '');
    };

    //handels the response from the h1 buttons
    //sets the h2Data and the h1Selected
    //rData is the response data from the api call to the h1 api
    //iData is the data that was sent to the api call
    //isStreamingData indicates if this is streaming content (true) or final content (false)
    //streamType indicates the type of streaming data ('chunk' or 'complete')
    const handleH1Response = (rData, iData, isStreamingData = false, streamType = 'complete') => {
        setH1Selected(iData);
        
        if (streamType === 'headline-selected') {
          setH2Data(null);
          setIsStreaming(false);
          setCurrentBlog(null);
        } else {
          setH2Data(rData);
          setIsStreaming(isStreamingData);
        }
      };


    return(
        <BrandVoiceProvider>
            <div className='Main'>
                {state === 'start' && (
                    <Trend change={() => navigateToState('new-trend') }
                            onClick={handleTrendResponse}
                    />
                )}

                {state === 'new-trend' && (
                    <ChooseTrend change={() => navigateToState('new-headline')}
                                onResponse={handleChooseTrendResponse}
                                trendData={trendData}
                                originalKeyword={originalKeyword}
                    />
                )}
                
                
                {state === 'new-headline' && (
                    <ChooseHeadline change={() => navigateToState('copy-download')}
                                    onResponse={handleH1Response}
                                    h1Data={h1Data}
                                    setH1Data={setH1Data}         
                    />
                )}
            
                {state === 'copy-download' && (
                    <CopyDownload h2Data={h2Data}
                                 h1Selected={h1Selected}
                                 selectedTrendQuery={selectedTrendQuery}
                                 setH2Data={setH2Data}
                                 isStreaming={isStreaming}
                                 setIsStreaming={setIsStreaming}
                                 currentBlog={currentBlog}
                                 setCurrentBlog={setCurrentBlog}
                                 refreshSidebar={refreshSidebar}
                    />
                )}

                {/* Navigation Component - only show when not coming from sidebar */}
                {!isFromSidebar && (
                    <div className="navigation-container">
                        {/* Breadcrumb Dots - always shown */}
                        <div className="breadcrumb-container">
                            {getBreadcrumbData().map((breadcrumb, index) => (
                                <div 
                                    key={breadcrumb.state}
                                    className={`breadcrumb-dot ${breadcrumb.isCompleted ? 'completed' : ''} ${breadcrumb.isCurrent ? 'current' : ''}`}
                                />
                            ))}
                        </div>
                        
                        {/* Back Button - Icon only, clean design */}
                        {state !== 'start' && (
                            <button 
                                className="back-button-icon-only"
                                onClick={navigateBack}
                                disabled={!previousState}
                                title="Vorige stap"
                            >
                                <span className="back-arrow">←</span>
                            </button>
                        )}
                    </div>
                )}
            </div>
        </BrandVoiceProvider>
    )
}